import { ENV_OPTIONS } from '@up/shared/injection-tokens';
import { EnvironmentOptions } from '@up/shared/interfaces';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { WebOrderReceiptRoutingModule } from './web-order-receipt-routing.module';
import { OrderReceiptComponent } from './components/order-receipt/order-receipt.component';
import { CartReceiptComponent } from './components/cart-receipt/cart-receipt.component';
import { FeedbackSectionComponent } from './components/feedback-section/feedback-section.component';
import { ErrorComponent } from './components/error/error.component';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { StarRatingModule } from "angular-star-rating";
import { LiveCartComponent } from "./components/live-cart/live-cart.component";
import { TipComponent } from "./components/tip/tip.component";
import { GiftCardReceiptComponent } from "./components/gift-card-receipt/gift-card-receipt.component";
import { StartShiftComponent } from "./components/cash-apron/start-shift/start-shift.component";
import { ApronErrorComponent } from "./components/cash-apron/apron-error/apron-error.component";
import { EndShiftComponent } from "./components/cash-apron/end-shift/end-shift.component";
import { CountIncorrectComponent } from "./components/cash-apron/child-components/count-incorrect/count-incorrect.component";
import { PinEntryComponent } from "./components/cash-apron/child-components/pin-entry/pin-entry.component";
import { CashDropComponent } from "./components/cash-apron/cash-drop/cash-drop.component";
import { QRCodeModule } from "angularx-qrcode";

@NgModule({
    declarations: [
        OrderReceiptComponent,
        CartReceiptComponent,
        ErrorComponent,
        ApronErrorComponent,
        FeedbackSectionComponent,
        LiveCartComponent,
        TipComponent,
        GiftCardReceiptComponent,
        StartShiftComponent,
        EndShiftComponent,
        CashDropComponent,
        CountIncorrectComponent,
        PinEntryComponent
    ],
    imports: [
        CommonModule,
        WebOrderReceiptRoutingModule,
        NgxBarcode6Module,
        NgSelectModule,
        FormsModule,
        NgxLoadingModule.forRoot({}),
        TranslateModule.forRoot(),
        StarRatingModule.forRoot(),
        FontAwesomeModule,
        QRCodeModule
    ],
    exports: [ErrorComponent, ApronErrorComponent]
})
export class WebOrderReceiptModule {
    static forRoot(
        environmentOptions: EnvironmentOptions
    ): ModuleWithProviders<WebOrderReceiptModule> {
        return {
            ngModule: WebOrderReceiptModule,
            providers: [
                {
                    provide: ENV_OPTIONS,
                    useValue: environmentOptions
                },
                DatePipe
            ]
        };
    }
}
